<template>
<ItpPage
  :size="size"
  :header="documentTitle"
  :loaded="loaded"
  :noShow="!loaded"
  :modal="modal"
  itp-cname="InvoiceReferenceSearch"
  :modalBindings="b_7315092382398562_modalBindings"
  @close="evh_7315092382398562_close($event, {})"
>
  <UcHeader
    :card="!modal"
    :modal="modal"
    :title="documentTitle"
    slot="header"
    v-if="loaded"
    @close="evh_2248226175642056_close($event, {})"
  >
  </UcHeader>
  <UcBody
    :card="!modal"
    :modal="modal"
    v-if="loaded"
  >
    <ItpForm
      name="search"
      :id="formId"
    >
      <DIV
        class="form-row"
      >
        <ItpSelect2
          name="selectedReference"
          v-model="selectedReference"
          :options="referenceTypes"
          valueField="target"
          textField="text"
          :clearable="b_7789867021953041_clearable"
          bind-object
          class="col-4"
          @selected="evh_7789867021953041_selected($event, {})"
        >
        </ItpSelect2>
        <ItpFormSelect2
          name="search"
          v-model="searchTerm"
          :placeholder="'Search...'|pgettext('Search Placeholder')"
          :dataSource="selectedReference && selectedReference.dataSource"
          :options="items"
          optionTemplate="<InvoiceReferenceSearchOption :option=option>
</InvoiceReferenceSearchOption>"
          use-option-template-for-selected-option
          class="col-8"
          @optionSelected="evh_3468003412020058_optionSelected($event, {})"
        >
        </ItpFormSelect2>
      </DIV>
      <b-list-group
        class="mt-3"
      >
        <b-list-group-item
          :key="item.id"
          v-for="item in selectedItems"
        >
          <ItpBox
            alignItems="start"
          >
            <InvoiceReferenceItem
              :item="item"
              no-link
            >
            </InvoiceReferenceItem>
            <button
              data-dismiss="modal"
              aria-label="Close"
              class="close ml-auto mr-1"
              @click="evh_6049458597007392_click($event, {item})"
            >
              <span aria-hidden="true">&times;</span>

            </button>
          </ItpBox>
        </b-list-group-item>
      </b-list-group>
    </ItpForm>
  </UcBody>
  <UcFooter
    :card="!modal"
    :modal="modal"
    slot="footer"
    v-if="loaded"
  >
    <ItpButton
      :text="'Add references'|pgettext('InvoiceReferenceSearch/Submit')"
      variant="primary"
      icon="fa-save"
      :spinning="actions.submitReferences && actions.submitReferences.isRunning"
      :disabled="!selectedItems.length"
      @click.prevent.stop="evh_1548630417156826_clickPreventStop($event, {})"
    >
    </ItpButton>
    <ItpButton
      :text="'Cancel'|gettext"
      variant="default"
      :disabled="(actions.search && actions.search.isRunning) || (actions.submitReferences && actions.submitReferences.isRunning)"
      @click.prevent.stop="evh_1419464017721962_clickPreventStop($event, {})"
    >
    </ItpButton>
  </UcFooter>
  <template
    slot="footer"
    v-if="loaded"
  >
  </template>
</ItpPage>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class InvoiceReferenceSearch extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "page",
  };

  beforeCreate() {
    this.$$cache_selectedReferenceType = new ComponentValueCache(this, "selectedReferenceType", "InvoiceReferenceSearchModal.selectedReferenceType");
  }

  onReferenceSelected(...args: any[]) {
    const { option, value } = args[0];
    if (option) {
      this.selectedItems.push(option);

      if (option.rental_id && option.rental_name) {
        this.selectedItems.push({
          object: 'rental',
          id: option.rental_id,
          name: option.rental_name
        });
      }

      if (option.client_id && option.client_name) {
        this.selectedItems.push({
          object: 'company',
          id: option.client_id,
          name: option.client_name
        });
      }
      if (option.properties) {
        _.each(option.properties, p => {
          if (p.object == 'rental_property' && !p.inactive && p.property_unit) {
            this.selectedItems.push({
              object: 'property_unit',
              id: p.property_unit.id,
              name: p.property_unit.full_name || p.property_unit.full_code
            });
          }
        })
      }
    }
  }

  @Prop({
    required: true,
    type: String,
  })
  invoiceId!: string;

  @Watch('invoiceId')
  onInvoice_id(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("invoiceId")
  }

  @Prop({
    type: String,
    default: "md",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  formId!: any;

  async $$load_formId() {
    return this.$fn.randomElementId()
  }

  searchTerm!: any;
  items!: any;
  selectedItems!: any;
  referenceTypes!: any;

  async $$load_referenceTypes() {
    return [
      {
        type: 'contract',
        text: this.$fn.gettext('Contracts'),
        target: 'contracts',
        dataSource: {
          name: 'suggest_contract',
          parameters: {}
        },
        template: '',
      },
      {
        type: 'rental',
        text: this.$fn.gettext('Rentals'),
        target: 'rentals',
        dataSource: {
          name: 'suggest_rental',
          parameters: {}
        },
      },
      {
        type: 'client',
        text: this.$fn.gettext('Clients'),
        target: 'tenants',
        dataSource: {
          name: 'suggest_company',
          parameters: {
            role: 'partner'
          }
        },
      },
      {
        type: 'property',
        text: this.$fn.gettext('Properties'),
        target: 'properties',
        dataSource: {
          name: 'suggest_property',
          parameters: {
            types: 'property,unit'
          }
        },
      },
    ]
  }

  selectedReferenceType!: any;
  selectedReference!: any;

  async $$load_selectedReference() {
    return _.find(this.referenceTypes, { type: this.selectedReferenceType }) || this.referenceTypes[0]
  }

  ux!: any;
  b_7315092382398562_modalBindings!: any;
  b_7789867021953041_clearable!: any;
  dataMembers = ['formId', 'searchTerm', 'items', 'selectedItems', 'referenceTypes', 'selectedReferenceType', 'selectedReference', 'ux', 'b_7315092382398562_modalBindings', 'b_7789867021953041_clearable'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        formId: null,
        searchTerm: null,
        items: [
        ]
        ,
        selectedItems: [
        ]
        ,
        referenceTypes: null,
        selectedReferenceType: null,
        selectedReference: null,
        ux: null,
        b_7315092382398562_modalBindings: {
          size: "md",
        }
        ,
        b_7789867021953041_clearable: false,
      },
    }
  }

  get document() {
    if (this.loaded) {

      return {
        title: this.$fn.pgettext("Invoice", "Search Reference"),
      }
    }
    return null;
  }

  async act_7315092382398562_closeModal_9208_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7315092382398562_closeModal_9208, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        cancel: true,
      }
      ,
    }
  }

  async evh_7315092382398562_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
  }

  async evh_2248226175642056_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
  }

  async act_7789867021953041_setData_9212_getActionArgs($event: actions.ActionEvent): Promise<actions.SetDataActionArgs> {
    // parameterResolver name=act_7789867021953041_setData_9212, alias=undefined
    return {
      path: "searchTerm",
      value: null,
      resolve: false,
      noTouchLastLoaded: false,
      noTakeSnapshot: false,
    }
  }

  async act_7789867021953041_setData_9214_getActionArgs($event: actions.ActionEvent): Promise<actions.SetDataActionArgs> {
    // parameterResolver name=act_7789867021953041_setData_9214, alias=undefined
    return {
      path: "items",
      value: [
      ]
      ,
      resolve: false,
      noTouchLastLoaded: false,
      noTakeSnapshot: false,
    }
  }

  async act_7789867021953041_setData_9216_getActionArgs($event: actions.ActionEvent): Promise<actions.SetDataActionArgs> {
    // parameterResolver name=act_7789867021953041_setData_9216, alias=undefined
    return {
      path: "selectedReferenceType",
      value: $event.data.type,
      resolve: false,
      noTouchLastLoaded: false,
      noTakeSnapshot: false,
    }
  }

  async evh_7789867021953041_selected(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7789867021953041_selected.executeFromDOM(this, event, scope);
  }

  async act_3468003412020058_script_9218_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_3468003412020058_script_9218, alias=undefined
    this.onReferenceSelected($event.data)
  }

  async act_3468003412020058_script_9218_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_3468003412020058_script_9218, alias=undefined
    return {
      value: () => this.act_3468003412020058_script_9218_getActionArgs_value($event),
    }
  }

  async evh_3468003412020058_optionSelected(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_3468003412020058_optionSelected.executeFromDOM(this, event, scope);
  }

  async act_6049458597007392_setData_9220_getActionArgs($event: actions.ActionEvent): Promise<actions.SetDataActionArgs> {
    // parameterResolver name=act_6049458597007392_setData_9220, alias=undefined
    return {
      path: "selectedItems",
      value: (_.remove(this.selectedItems, $event.scope.item), this.selectedItems.slice()),
      resolve: false,
      noTouchLastLoaded: false,
      noTakeSnapshot: false,
    }
  }

  async evh_6049458597007392_click(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_6049458597007392_click.executeFromDOM(this, event, scope);
  }

  async act_1548630417156826_closeComponent_9224_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseComponentActionArgs> {
    // parameterResolver name=act_1548630417156826_closeComponent_9224, alias=undefined
    return {
      result: {
        ok: true,
      }
      ,
    }
  }

  async act_1548630417156826_request_9222_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_1548630417156826_request_9222, alias=submitReferences
    return {
      operation: "create_invoice_reference",
      data: _.map(this.selectedItems, p => ({ reference_id: p.id })),
      parameters: {
        invoice_id: this.invoiceId,
      }
      ,
    }
  }

  async evh_1548630417156826_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1548630417156826_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async evh_1419464017721962_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1419464017721962_clickPreventStop.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_closeModal_9208: actions.CloseModalAction;
    evh_7315092382398562_close_9207: actions.EventHandlerImpl;
    evh_7315092382398562_close: actions.EventHandlerGroup;
    act_2248226175642056_closeComponent_9210: actions.CloseComponentAction;
    evh_2248226175642056_close_9209: actions.EventHandlerImpl;
    evh_2248226175642056_close: actions.EventHandlerGroup;
    act_7789867021953041_setData_9212: actions.SetDataAction;
    evh_7789867021953041_selected_9211: actions.EventHandlerImpl;
    act_7789867021953041_setData_9214: actions.SetDataAction;
    evh_7789867021953041_selected_9213: actions.EventHandlerImpl;
    act_7789867021953041_setData_9216: actions.SetDataAction;
    evh_7789867021953041_selected_9215: actions.EventHandlerImpl;
    evh_7789867021953041_selected: actions.EventHandlerGroup;
    act_3468003412020058_script_9218: actions.ScriptAction;
    evh_3468003412020058_optionSelected_9217: actions.EventHandlerImpl;
    evh_3468003412020058_optionSelected: actions.EventHandlerGroup;
    act_6049458597007392_setData_9220: actions.SetDataAction;
    evh_6049458597007392_click_9219: actions.EventHandlerImpl;
    evh_6049458597007392_click: actions.EventHandlerGroup;
    act_1548630417156826_closeComponent_9224: actions.CloseComponentAction;
    evh_1548630417156826_success_9223: actions.EventHandlerImpl;
    act_1548630417156826_request_9222: actions.RequestAction;
    evh_1548630417156826_clickPreventStop_9221: actions.EventHandlerImpl;
    evh_1548630417156826_clickPreventStop: actions.EventHandlerGroup;
    act_1419464017721962_closeComponent_9226: actions.CloseComponentAction;
    evh_1419464017721962_clickPreventStop_9225: actions.EventHandlerImpl;
    evh_1419464017721962_clickPreventStop: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_closeModal_9208 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7315092382398562_closeModal_9208_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_9207 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_closeModal_9208,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_7315092382398562_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_close_9207],
      }
    );
    const act_2248226175642056_closeComponent_9210 = new actions.CloseComponentAction(
      {
        events: [],
      }
    );
    const evh_2248226175642056_close_9209 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_closeComponent_9210,
        event: "close",
        displayName: "closeComponent",
      }
    );
    const evh_2248226175642056_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_close_9209],
      }
    );
    const act_7789867021953041_setData_9212 = new actions.SetDataAction(
      {
        actionArgs: this.act_7789867021953041_setData_9212_getActionArgs,
        events: [],
      }
    );
    const evh_7789867021953041_selected_9211 = new actions.EventHandlerImpl(
      {
        action: act_7789867021953041_setData_9212,
        event: "selected",
        displayName: "setData",
      }
    );
    const act_7789867021953041_setData_9214 = new actions.SetDataAction(
      {
        actionArgs: this.act_7789867021953041_setData_9214_getActionArgs,
        events: [],
      }
    );
    const evh_7789867021953041_selected_9213 = new actions.EventHandlerImpl(
      {
        action: act_7789867021953041_setData_9214,
        event: "selected",
        displayName: "setData",
      }
    );
    const act_7789867021953041_setData_9216 = new actions.SetDataAction(
      {
        actionArgs: this.act_7789867021953041_setData_9216_getActionArgs,
        events: [],
      }
    );
    const evh_7789867021953041_selected_9215 = new actions.EventHandlerImpl(
      {
        action: act_7789867021953041_setData_9216,
        event: "selected",
        displayName: "setData",
      }
    );
    const evh_7789867021953041_selected = new actions.EventHandlerGroup(
      {
        handlers: [evh_7789867021953041_selected_9211, evh_7789867021953041_selected_9213, evh_7789867021953041_selected_9215],
      }
    );
    const act_3468003412020058_script_9218 = new actions.ScriptAction(
      {
        actionArgs: this.act_3468003412020058_script_9218_getActionArgs,
        events: [],
      }
    );
    const evh_3468003412020058_optionSelected_9217 = new actions.EventHandlerImpl(
      {
        action: act_3468003412020058_script_9218,
        event: "optionSelected",
        displayName: "script",
      }
    );
    const evh_3468003412020058_optionSelected = new actions.EventHandlerGroup(
      {
        handlers: [evh_3468003412020058_optionSelected_9217],
      }
    );
    const act_6049458597007392_setData_9220 = new actions.SetDataAction(
      {
        actionArgs: this.act_6049458597007392_setData_9220_getActionArgs,
        events: [],
      }
    );
    const evh_6049458597007392_click_9219 = new actions.EventHandlerImpl(
      {
        action: act_6049458597007392_setData_9220,
        event: "click",
        displayName: "setData",
      }
    );
    const evh_6049458597007392_click = new actions.EventHandlerGroup(
      {
        handlers: [evh_6049458597007392_click_9219],
      }
    );
    const act_1548630417156826_closeComponent_9224 = new actions.CloseComponentAction(
      {
        actionArgs: this.act_1548630417156826_closeComponent_9224_getActionArgs,
        events: [],
      }
    );
    const evh_1548630417156826_success_9223 = new actions.EventHandlerImpl(
      {
        action: act_1548630417156826_closeComponent_9224,
        event: "success",
        displayName: "closeComponent",
      }
    );
    const act_1548630417156826_request_9222 = new actions.RequestAction(
      {
        actionArgs: this.act_1548630417156826_request_9222_getActionArgs,
        displayName: "submitReferences",
        events: [evh_1548630417156826_success_9223],
      }
    );
    const evh_1548630417156826_clickPreventStop_9221 = new actions.EventHandlerImpl(
      {
        action: act_1548630417156826_request_9222,
        event: "click.prevent.stop",
        displayName: "submitReferences",
      }
    );
    const evh_1548630417156826_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_1548630417156826_clickPreventStop_9221],
      }
    );
    const act_1419464017721962_closeComponent_9226 = new actions.CloseComponentAction(
      {
        events: [],
      }
    );
    const evh_1419464017721962_clickPreventStop_9225 = new actions.EventHandlerImpl(
      {
        action: act_1419464017721962_closeComponent_9226,
        event: "click.prevent.stop",
        displayName: "closeComponent",
      }
    );
    const evh_1419464017721962_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_1419464017721962_clickPreventStop_9225],
      }
    );
    return {
      act_7315092382398562_closeModal_9208,
      evh_7315092382398562_close_9207,
      evh_7315092382398562_close,
      act_2248226175642056_closeComponent_9210,
      evh_2248226175642056_close_9209,
      evh_2248226175642056_close,
      act_7789867021953041_setData_9212,
      evh_7789867021953041_selected_9211,
      act_7789867021953041_setData_9214,
      evh_7789867021953041_selected_9213,
      act_7789867021953041_setData_9216,
      evh_7789867021953041_selected_9215,
      evh_7789867021953041_selected,
      act_3468003412020058_script_9218,
      evh_3468003412020058_optionSelected_9217,
      evh_3468003412020058_optionSelected,
      act_6049458597007392_setData_9220,
      evh_6049458597007392_click_9219,
      evh_6049458597007392_click,
      act_1548630417156826_closeComponent_9224,
      evh_1548630417156826_success_9223,
      act_1548630417156826_request_9222,
      evh_1548630417156826_clickPreventStop_9221,
      evh_1548630417156826_clickPreventStop,
      act_1419464017721962_closeComponent_9226,
      evh_1419464017721962_clickPreventStop_9225,
      evh_1419464017721962_clickPreventStop,
      submitReferences: act_1548630417156826_request_9222,
    }
  }
}

Vue.component("InvoiceReferenceSearch", InvoiceReferenceSearch);

</script>